import { ROUTE_CONFIG } from "@/routes/config";

import { CustomListsAutocompleteForSequencerItem } from "../../List/components/CustomListsAutocompleteForSequencer";
import { List } from "../../List/schema/list";
import { Tabs } from "../../List/pages/Unassigned/unassignedTabs";

import { DeepDiveCampaignRef } from "../components/DeepDiveActions";
import { ContactsNavigationResult } from "./buildContactsNavigation";

const CONTACTS_FILTER_PARAM_KEY = "contacts_filter";

/**
 * "View leads" for a selection, following the same rule as a clicked KPI: one list opens
 * that list's own leads view, several open Contacts — the only view that spans lists.
 *
 * Unlike the KPI drill-through this carries no metric filter: the button means "show me
 * these leads", not "show me the leads behind this number".
 */
export function buildLeadsNavigation(
	selectedLists: CustomListsAutocompleteForSequencerItem[]
): ContactsNavigationResult {
	const ids = selectedLists
		.map((list) => list.id)
		.filter((id): id is number => typeof id === "number");

	if (ids.length === 1) {
		return {
			pathname: `${ROUTE_CONFIG.LISTS_DETAIL}/${ids[0]}`,
			search: new URLSearchParams({ tab: Tabs.ASSIGNED }).toString(),
		};
	}

	const params = new URLSearchParams();

	if (ids.length > 1) {
		params.set(
			CONTACTS_FILTER_PARAM_KEY,
			JSON.stringify({
				list: {
					value: selectedLists
						.filter((list) => typeof list.id === "number")
						.map((list) => ({ id: String(list.id), title: list.title })),
					type: "dropdown",
					filterParam: "list_person.listId",
				},
			})
		);
	}

	return { pathname: ROUTE_CONFIG.CONTACTS, search: params.toString() };
}

/**
 * The saved sequence of a campaign, read from the loaded lists.
 *
 * Returns null when the list is not in the currently loaded page — the modal then shows
 * its "no steps" state rather than inventing a sequence.
 */
export function campaignNodesOf(listData: List[], campaign: DeepDiveCampaignRef): unknown {
	const list = listData.find((candidate) => candidate.id === campaign.listId);
	const config = list?.campaignConfig as Record<string, { initialNodes?: unknown }> | undefined;

	return config?.[campaign.campaignId]?.initialNodes ?? null;
}
